<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { inject, ref } from 'vue';
  import { useApplianceStore } from '~/stores/appliance';
  import CustomTable from './Base/CustomTable.vue';
  import CustomTextInput from './Base/CustomTextInput.vue';

  //variables
  const store = useApplianceStore();
  const { setSerialNumber, loadPollutants } = store;
  const { serialNumber, pollutants, articleDescription, sku, getReachGuid } =
    storeToRefs(store);
  const errorOccured = ref<boolean>(false);
  const createToast: any = inject('createToast');
</script>

<template>
  <!-- SerialNumberInput -->
  <CustomTextInput
    class="itde:my-14"
    :value="serialNumber"
    @update-value="(_value: string) => setSerialNumber(_value)"
    @svhc-action-clicked="
      loadPollutants().catch((reason) => {
        createToast(null, $t('general.network-error'), 'error');
        console.log(reason);
      })
    "
  >
    <template #input-text>
      {{ $t('appliance.serialnumber-input') }}
    </template>
  </CustomTextInput>

  <!-- Divider -->
  <hr :class="$gStyle('my-[36px]! h-0.5 border-t-0 bg-neutral-300')" />

  <!-- Table -->
  <CustomTable :data="pollutants" :error-occured="errorOccured" :serialnumber="serialNumber">
    <!-- Custom Table Header -->
    <template #custom-table-header>
      <patternlib-headline
        heading-tag="h6"
        :headline="$t('table.sku-text', { sku: sku })"
        :class="$gStyle('mb-6')"
      />
      <div>{{ $t('table.model-text', { model: articleDescription }) }}</div>
      <div v-if="getReachGuid">
        {{ $t('table.scip-text', { scipNumber: getReachGuid }) }}
      </div>
    </template>

    <!-- Overview Content Table -->
    <patternlib-table-base>
      <!-- Table Header -->
      <tr slot="head">
        <th>{{ $t('general.articleNumber-text') }}</th>
        <th>{{ $t('general.article-text') }}</th>
        <th>{{ $t('general.substance-name') }}</th>
        <th>{{ $t('general.cas-number') }}</th>
      </tr>

      <!-- Table Content -->
      <patternlib-table-base-row v-for="pollutant in pollutants">
        <!-- Id -->
        <patternlib-table-base-cell noBorder id="articlenumber">{{
          pollutant.articleNumberPart
        }}</patternlib-table-base-cell>
        <!-- AttributeId -->
        <patternlib-table-base-cell noBorder id="articleQualifier">{{
          pollutant.productName
        }}</patternlib-table-base-cell>
        <!-- ColumnName -->
        <patternlib-table-base-cell noBorder id="substance">{{
          pollutant.substanceName
        }}</patternlib-table-base-cell>
        <!-- Description -->
        <patternlib-table-base-cell noBorder id="cas">{{
          pollutant.cas
        }}</patternlib-table-base-cell>
      </patternlib-table-base-row>
    </patternlib-table-base>
  </CustomTable>
</template>

<style scoped></style>
